export class ApiError extends Error {
  constructor({ status, code, message, fields }) {
    super(message);

    this.status = status;
    this.code = code;
    this.fields = [];

    if (fields) {
      Object.entries(fields).forEach(pair => {
        const [name, messages] = pair;
        const firstMessage = Array.isArray(messages) ? messages.shift() : messages;

        this.fields.push({
          name,
          message: firstMessage
        });
      });
    }
  }
}

export default function errorHandler(response) {
  if (!response.response) {
    return Promise.reject(new Error('Falha na comunicação com a API.'));
  }

  const { data, status } = response.response;

  if (!data) {
    return Promise.reject(new ApiError({ status, message: 'Erro genérico.' }));
  }

  return Promise.reject(
    new ApiError({
      status,
      code: data.error.code,
      message: data.error.message,
      fields: data.error.fields
    })
  );
}
